export default __webpack_public_path__ + "static/media/jcb.355d4e71.jpg";